import { PrimaryColors } from 'src/types/globalTypes';
import DropdownInfo from 'src/components/ui-kit/DropdownInfo';
import { PatentPriority } from 'src/types/api/patentRightsApiTypes';
import { Table, Item, Title, Content } from 'src/components/contents/detail/DetailPage';

interface Iprops {
  data: PatentPriority;
  isShow: boolean;
  setIsShow: (isShow: boolean) => void;
  colorType: PrimaryColors;
  noContent: JSX.Element;
}

/**
 * 專利優先權案 區塊。
 */
const InfoPatentPriority: React.FC<Iprops> = ({
  data,
  isShow,
  setIsShow,
  colorType,
  noContent,
}) => {
  const tableColor = colorType.third;
  const angleColor = colorType.fifth;
  return (
    <DropdownInfo title={`專利優先權案`} isShow={isShow} setIsShow={setIsShow} color={angleColor}>
      {data.priorities.map((item) => {
        return (
          <Table color={tableColor} key={item.sequence}>
            <Item>
              <Title>優先權序號</Title>
              <Content>{item.sequence || noContent}</Content>
              <Title>優先權國家代碼</Title>
              <Content>{item.priorityCountryCode || noContent}</Content>
            </Item>
            <Item>
              <Title>優先權國家</Title>
              <Content>{item.priorityCountryName || noContent}</Content>
              <Title>優先權案號</Title>
              <Content>{item.priorityApplyNo || noContent}</Content>
            </Item>
            <Item>
              <Title>優先權日期</Title>
              <Content>{item.priorityDate || noContent}</Content>
            </Item>
          </Table>
        );
      })}
    </DropdownInfo>
  );
};

export default InfoPatentPriority;
